export default "__VITE_ASSET__2fIg8xRA__"